import React, { useState } from 'react';
import { updateNotificationSetting } from '../components/DbServices';
import { getStoredUser } from '../utilities/encryption';
import Swal from 'sweetalert2';

export default function NotificationSettings({ user }) {
  // Parse the JSON string from the database column
  const savedSettings = user?.notificationsetting ? JSON.parse(user.notificationsetting) : {
    email_Swals: true,
    low_credits: true,
    device_offline: false,
    security_logs: true
  };

  const [settings, setSettings] = useState(savedSettings);
  const [loading, setLoading] = useState(false);

  const handleToggle = (key) => {
    setSettings(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const saveSettings = async () => {
    setLoading(true);
    const jsonString = JSON.stringify(settings);

    try {
      const res = await updateNotificationSetting({ 
        user_id: user.id, 
        notificationsetting: jsonString 
      });

      if (res.status === 200) {
        // Sync LocalStorage so settings persist on refresh
        const session = getStoredUser();
        session.data.notificationsetting = jsonString;
        localStorage.setItem('user', JSON.stringify(session));
        
        Swal.fire("Notification preferences saved!");
      }
    } catch (error) {
      Swal.fire("Error saving settings");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h5 className="fw-bold mb-1">Notification Settings</h5>
      <p className="text-muted small mb-4">Choose which Swals you'd like to receive via email and dashboard.</p>

      <div className="card border-0 bg-light rounded-4 p-3 mb-4">
        <NotificationToggle 
          label="Email Swals" 
          description="Receive daily summaries of your API usage."
          isActive={settings.email_Swals}
          onToggle={() => handleToggle('email_Swals')}
        />
        <hr className="my-2 opacity-25" />
        <NotificationToggle 
          label="Low Credit Warning" 
          description="Swal me when my message balance is below 10%."
          isActive={settings.low_credits}
          onToggle={() => handleToggle('low_credits')}
        />
        <hr className="my-2 opacity-25" />
        <NotificationToggle 
          label="Device Offline" 
          description="Get notified immediately if a WhatsApp instance disconnects."
          isActive={settings.device_offline}
          onToggle={() => handleToggle('device_offline')}
        />
      </div>

      <button 
        className="btn btn-primary px-4 rounded-3 shadow-sm" 
        onClick={saveSettings}
        disabled={loading}
      >
        {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : <i className="fas fa-check-circle me-2"></i>}
        {loading ? 'Saving...' : 'Save Preferences'}
      </button>
    </div>
  );
}

function NotificationToggle({ label, description, isActive, onToggle }) {
  return (
    <div className="d-flex align-items-center justify-content-between py-2">
      <div>
        <h6 className="mb-0 fw-bold small">{label}</h6>
        <p className="text-muted small mb-0">{description}</p>
      </div>
      <div className="form-check form-switch">
        <input 
          className="form-check-input" 
          type="checkbox" 
          role="switch" 
          checked={isActive} 
          onChange={onToggle}
          style={{ cursor: 'pointer', width: '2.4em', height: '1.2em' }}
        />
      </div>
    </div>
  );
}